/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

import type { EllipticCurvePublicKey } from './EllipticCurvePublicKey';

export type EncryptionSpecification = {
    /**
     * Description of the key agreement algorithm requested by the client.
     *
     */
    alg: EncryptionSpecification.alg;
    /**
     * Description of the symmetric content encryption key. Conditional - Mandatory only when encryption (field "alg") is in place (not with PLAIN_TEXT)
     *
     */
    enc?: EncryptionSpecification.enc;
    epk?: EllipticCurvePublicKey;
};

export namespace EncryptionSpecification {

    /**
     * Description of the key agreement algorithm requested by the client.
     *
     */
    export enum alg {
        ECDH_ES_A128KW = 'ECDH_ES_A128KW',
        ECDH_ES_A256KW = 'ECDH_ES_A256KW',
        PLAIN_TEXT = 'PLAIN_TEXT',
    }

    /**
     * Description of the symmetric content encryption key. Conditional - Mandatory only when encryption (field "alg") is in place (not with PLAIN_TEXT)
     *
     */
    export enum enc {
        A128GCM = 'A128GCM',
        A256GCM = 'A256GCM',
    }


}

